import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import i18n from './i18n'
i18n.locale = store.state.lang

import './assets/styles/main.css';

import { library } from '@fortawesome/fontawesome-svg-core'
import { faCode, faServer, faLifeRing, faThumbsUp, faThumbsDown, faUserPlus, faFolderOpen, faClipboard, faClipboardList, faClipboardCheck, faHeart } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import VueParticles from 'vue-particles'

Vue.config.productionTip = false

library.add(faCode, faServer, faLifeRing, faThumbsUp, faThumbsDown, faUserPlus, faFolderOpen, faClipboard, faClipboardList, faClipboardCheck, faHeart)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(VueParticles)

const app = new Vue({
  el: '#app',
  i18n,
  router,
  store,
  render: h => h(App)
})
if (module.hot) {
  module.hot.accept(['./locales/en.json', './locales/bs.json'], function () {
    app.$i18n.setLocaleMessage('en', require('./locales/en.json').default)
    app.$i18n.setLocaleMessage('bs', require('./locales/bs.json').default)
  })
}
